<div class="flex items-center justify-center h-screen ztablet-min:bg-gray-100">
  <div
    class="flex flex-col items-start justify-center max-w-md w-full rounded-xl p-4"
  >
    <img
      class="w-48 h-auto mx-auto mb-6"
      [ngSrc]="
        isLightMode()
          ? '../../../../assets/icons/logo-j-connected_blue_2.png'
          : '../../../../assets/icons/logo-j-connected_white.png'
      "
      height="79"
      width="190"
      alt="Johnston's Connected"
      priority
    />
    <h1 class="text-2xl">Enter new password</h1>
    <p class="text-xs text-gray-400 mb-2">
      Password must be at least 8 characters long and include at least one
      uppercase letter, one lowercase letter, one number, and one special
      character (e.g., &#64;, #, $, !, %, *, ?, &)
    </p>
    <form [formGroup]="newPasswordForm" (ngSubmit)="onSubmit()">
      <mat-form-field class="w-full">
        <mat-label>New Password</mat-label>
        <input
          [type]="hideNewPassword ? 'password' : 'text'"
          matInput
          formControlName="newPassword"
          placeholder="Your new password"
        />
        <button
          matSuffix
          mat-icon-button
          type="button"
          (click)="toggleNewPasswordVisibility()"
          [attr.aria-label]="
            hideNewPassword ? 'Show password' : 'Hide password'
          "
          class="password-toggle-btn"
        >
          <mat-icon>{{
            hideNewPassword ? "visibility" : "visibility_off"
          }}</mat-icon>
        </button>
        @if (newPasswordForm.get('newPassword')?.hasError('required')) {
        <mat-error> New password is required. </mat-error>
        } @if (newPasswordForm.get('newPassword')?.hasError('pattern')) {
        <mat-error> Password requirements are not met. See the hint </mat-error>
        }
      </mat-form-field>
      <mat-form-field class="w-full">
        <mat-label>Confirm Password</mat-label>
        <input
          #passwordInput
          [type]="hideConfirmPassword ? 'password' : 'text'"
          matInput
          formControlName="confirmPassword"
          placeholder="Confirm your new password"
        />
        <button
          matSuffix
          mat-icon-button
          type="button"
          (click)="toggleConfirmPasswordVisibility()"
          [attr.aria-label]="
            hideConfirmPassword ? 'Show password' : 'Hide password'
          "
          class="password-toggle-btn"
        >
          <mat-icon>{{
            hideConfirmPassword ? "visibility" : "visibility_off"
          }}</mat-icon>
        </button>
        @if (newPasswordForm.get('confirmPassword')?.hasError('mismatch')) {
        <mat-error> Passwords do not match. </mat-error>
        }
      </mat-form-field>

      <button
        type="submit"
        class="bg-custom-orange text-white text-md p-3 rounded-xl mt-4 w-full"
      >
        Submit
      </button>
    </form>
  </div>
</div>
